module.exports = __webpack_public_path__ + "assets/icon-questionmark.ef72b71d.svg";